import React, { useContext } from 'react'
import { SideberContext } from '../context/SidebarContext'
import { NavLink } from 'react-router-dom';
import { ApiContext } from '../context/ApiContext';
import { useTranslation } from 'react-i18next';
function Settings() {
  const { mySidebarSetting, setMySidebarSetting, myNotification, setMyNotification, ourService, setOurService,language, setLanguage } = useContext(SideberContext)
  const { data } = useContext(ApiContext)
  const {t} = useTranslation();
  // console.log(mySidebarSetting,"sidebar");

  return (
    <>
      {data ? <div className={mySidebarSetting ? 'setting-main-active' : "setting-main-unactive"} onClick={() => setMySidebarSetting(false)}>
        <div className={mySidebarSetting ? "setting-main-inner-active" : "setting-main-inner-unactive"} onClick={(e) => e.stopPropagation()}>
          <ul className='settings-unordered-list'>
            <li className='settings-list-item' onClick={() => { setMySidebarSetting(false); setMyNotification(true); setOurService(true);setLanguage(false) }}>{t("Navbar.Option1")}</li>
            <li className='settings-list-item' onClick={() => { setMySidebarSetting(false); setMyNotification(true); setOurService(false);setLanguage(false) }}>{t("Navbar.Option2")}</li>
            <NavLink to={data.privacy_policy} target="_blank"><li className='settings-list-item' >{t("Navbar.Option3")}</li></NavLink>
            {/* <li className='settings-list-item' onClick={() => { setMySidebarSetting(false); setMyNotification(true); setOurService(false);setLanguage(true);  }}>{t("Navbar.Option4")}</li> */}
          </ul>
        </div>

      </div> : <div>Finding</div>}
    </>
  )
}

export default Settings